import React, { useState, useContext, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { addOrRemoveItem, basketGlobalError } from 'modules/basket/actions'
import plusIcon from '../../../assets/images/plus.svg'
import plusCircleIcon from '../../../assets/images/plus-circle.svg'
import minusCircleIcon from '../../../assets/images/minus-circle.svg'
import { LanguageContext } from 'context/LanguageContext'
import { util } from 'utils'
import { isDeliveryMode } from 'utils/appUtils'
import Button from '../button'
import { Container, useDialog } from '../modal/Modal'
import SelectAddress from 'components/selectAddress'
import { AiOutlineClose } from '@react-icons/all-files/ai/AiOutlineClose'
import AddressOptions from 'components/addressOptions'
import Util from 'utils/Util'
import { ClearCartPopUp } from '../counter/clearCartPopUp'
import ModeSwitchPopUp from '../modeSwitchPopUp'

const basketUpdateUrls = ['/checkout']

const CustomAddButtonWithCount = ({
    counter,
    incrementCounter,
    decrementCounter,
    hideAvailabilityContents,
    productDetails,
    errorMessage,
    cssFlag,
    basket,
    disableAddButton
}) => {
    const globalError = useSelector(state => state.basket.getIn(['glolbalError']))
    const { strings } = useContext(LanguageContext)

    const onPlusClickHandler = (e) => {
        if (disableAddButton) return
        incrementCounter(e)
    }
    const onMinusClickHandler = (e) => {
        decrementCounter(e)
    }
    return (
        <div className='custom-add-to-cart-button-container'>
            <div className='custom-add-to-cart-button-container-counter' onClick={(e) => e.preventDefault()}>
                <img className='custom-add-to-cart-button-container-counter-icon' src={minusCircleIcon} alt='Minus Circle Icon' onClick={onMinusClickHandler} />
                <div className='custom-add-to-cart-button-container-counter-count'>
                    <span className='custom-add-to-cart-button-container-counter-count-data'>
                        {counter}
                    </span>
                </div>
                <img className={`custom-add-to-cart-button-container-counter-icon ${disableAddButton ? 'add-disable' : ''}`} src={plusCircleIcon} alt='Plus Circle Icon' onClick={onPlusClickHandler} />
            </div>
            {!hideAvailabilityContents ? (
                <>
                    <div
                        className={`custom-add-to-cart-button-container-info-text${productDetails ? '-details' : ''
                            } ${basket && 'basket-availability'} ${cssFlag}`}
                        tabIndex="0"
                        aria-label={strings.addedToBasket}
                    >
                        {globalError
                            ? globalError
                            : errorMessage
                                ? errorMessage
                                : counter > 0
                                    ? strings.addedToBasket
                                    : null}{' '}
                    </div>{' '}
                </>
            ) : null}
        </div>

    )
}
const CustomAddToCartButton = ({
    product,
    basket = false,
    mixpanelFlagForAi,
    mixpanelFlagForSearch,
    hideAvailabilityContents,
    productDetails = false,
    cssFlag,
    setShowDateTimePicker,
}) => {
    const { strings } = useContext(LanguageContext)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [dialogOpen, setDialogOpen] = useState(false)
    const selectedAddress = useSelector(state => state.location.getIn(['selectedAddress']))
    const cateringAddress = useSelector(state => state.catering?.address)
    const cateringSchedule = useSelector(state => state.catering?.schedule)
    const isCateringMode = useSelector(state => state.appSettings.get('isCateringMode'))
    const isFrom7RewardsView = useSelector(state => state.appSettings.get('isApp'))
    const basketItems = useSelector(state => state.basket.getIn(['basketItems']))
    const globalCanAdd = useSelector(state => state.basket.getIn(['canAddItems']))
    const globalError = useSelector(state => state.basket.getIn(['glolbalError']))
    const itemsAddedToCart = basketItems ? basketItems.toJS() : []
    const { isSignedIn } = util.getJWTDetails()
    const { pathname, search } = useLocation()
    const [counter, setCounter] = useState(0)
    const [errorMessage, setErrorMessage] = useState('')
    const [canAddItem, setCanAddItem] = useState(true)
    const isDelivery = isDeliveryMode()
    const isPlatter = product?.platter_item_flag === '1'
    const isOnCateringRoute = pathname.indexOf('/catering') === 0
    const isInCateringContext = isOnCateringRoute || new URLSearchParams(search).get('tab') === 'catering'
    const disableAddButton = !canAddItem || !globalCanAdd

    useEffect(() => {
        const { count } = util.productExistsInCart(product)
        const { canAdd, error, isGlobal } = util.canAddItem(product)
        setCounter(count)
        if (isGlobal) {
            dispatch(basketGlobalError(error, canAdd))
        } else {
            setErrorMessage(error)
            setCanAddItem(canAdd)
            if (globalError) {
                dispatch(basketGlobalError('', true))
            }
        }
    }, [product, basketItems])


    const incrementCounter = (e) => {
        e.preventDefault()
        // 'Establishing connection with Android Interface from Add Items',
        if (window.androidDeliveryJSBridge && !isSignedIn) {
            window.androidDeliveryJSBridge.initiateGuestUserSignInRegister()
        }

        // 'Establishing connection with iOS Interface from Add Items',
        if (
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.deeplink &&
            !isSignedIn
        ) {
            window.webkit.messageHandlers.deeplink.postMessage('initiateGuestUserSignInRegister')
        }
        if (!isFrom7RewardsView || (isFrom7RewardsView && isSignedIn)) {
            if (isPlatter && !isInCateringContext) {
                const hasShopItems = itemsAddedToCart.length > 0 && !Util.checkForPreOrderItems(itemsAddedToCart)
                // If increasing quantity of platter already in cart, allow adding
                if (counter > 0) {
                    setCounter((pre) => pre + 1)
                    dispatch(
                        addOrRemoveItem(
                            product,
                            'add',
                            basketUpdateUrls.includes(pathname),
                            mixpanelFlagForAi,
                            mixpanelFlagForSearch
                        )
                    )
                } else if (hasShopItems) {
                    setDialogOpen(true)
                } else {
                    navigate('/catering', { state: { pendingProduct: product } })
                }
                return
            }

            if (Util.checkForMixedCartTypeItems(itemsAddedToCart, product)) {
                setDialogOpen(true)
            } else {
                setCounter((pre) => pre + 1)
                dispatch(
                    addOrRemoveItem(
                        product,
                        'add',
                        basketUpdateUrls.includes(pathname),
                        mixpanelFlagForAi,
                        mixpanelFlagForSearch
                    )
                )
            }
        }
    }

    const decrementCounter = (e) => {
        e.preventDefault()
        if (counter === 0) return
        setCounter((pre) => pre - 1)
        dispatch(
            addOrRemoveItem(
                product,
                'remove',
                basketUpdateUrls.includes(pathname),
                mixpanelFlagForAi,
                mixpanelFlagForSearch
            )
        )
    }

    const { on, hide, show, getToggleProps, getContainerProps } = useDialog()


    if (counter) {
        return (
            <CustomAddButtonWithCount
                counter={counter}
                incrementCounter={incrementCounter}
                decrementCounter={decrementCounter}
                hideAvailabilityContents={hideAvailabilityContents}
                productDetails={productDetails}
                errorMessage={errorMessage}
                cssFlag={cssFlag}
                basket={basket}
                disableAddButton={disableAddButton}
            />
        )
    }

    if (dialogOpen) {
        return (
            <ModeSwitchPopUp
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                targetMode={isPlatter && !isInCateringContext ? 'catering' : 'home'}
                search={search}
            />
        )
    }

    // Platter items on catering context (route or search tab): require address + schedule
    // Platter items elsewhere (Deals etc.): always show ADD (clicking navigates to catering)
    // Regular items: require address based on delivery/catering mode
    const hasRequiredData = isPlatter && isInCateringContext
        ? (cateringAddress && cateringSchedule?.isValid)
        : isPlatter
        ? true
        : ((!isCateringMode && selectedAddress) || (isCateringMode && cateringAddress))

    return hasRequiredData ? (
        <div className='custom-add-to-cart-button-container'>
            <button className={`custom-add-to-cart-button ${disableAddButton ? 'add-disable' : ''}`} onClick={incrementCounter} disabled={disableAddButton}>
                <img className={`custom-add-to-cart-button-icon ${disableAddButton ? 'add-disable' : ''}`} src={plusIcon} alt='Plus Icon' />
                <span className='custom-add-to-cart-button-text' >{strings.addToCartButton}</span>
            </button>
            {!hideAvailabilityContents ? (
                <>
                    <div
                        className={`custom-add-to-cart-button-container-info-text${productDetails ? '-details' : ''
                            } ${basket && 'basket-availability'} ${cssFlag}`}
                        tabIndex="0"
                        aria-label={strings.addedToBasket}
                    >
                        {globalError
                            ? globalError
                            : errorMessage
                                ? errorMessage
                                : counter > 0
                                    ? strings.addedToBasket
                                    : null}{' '}
                    </div>{' '}
                </>
            ) : null}
        </div>
    ) : (
        <div className={`product-description-add${productDetails ? '-details' : ''} ${cssFlag}`}>
            {productDetails ? (
                <>
                    <Button className={'availability'} {...getToggleProps()}>
                        {strings.checkAvailability}
                    </Button>{' '}
                    {on && (
                        <Container {...getContainerProps()}>
                            <div className={'signinform'}>
                                <Button
                                    {...getToggleProps()}
                                    aria-label="close modal"
                                    className="closeModal"
                                >
                                    <AiOutlineClose className={'close'} />
                                </Button>
                                {/* <SelectAddress hide={hide} show={show} /> */}
                                <AddressOptions hide={hide} show={show} setShowDateTimePicker={setShowDateTimePicker} />
                            </div>
                        </Container>
                    )}
                </>
            ) : (
                <>
                    {!hideAvailabilityContents
                        ? product.catalog_price && (
                            <span className={'from'}>
                                {strings.from}
                                {util.formatPrice(product.catalog_price)}
                            </span>
                        )
                        : null}
                </>
            )}
        </div>
    )
}

export default CustomAddToCartButton